export default {"src":"/_next/static/media/propertyDamage_24.773d41db.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};